import {
    buildListParams,
    getListData,
    getTotalRecords,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles,
    loadStoredJson,
    removeStoredKeys,
    saveStoredValue
} from 'lib/listUtils';
import {
    Card,
    CardContent,
    FormControl,
    FormLabel,
    Input,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    Tooltip
} from '@material-ui/core';
import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import api from '../../../services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { isFlagAtiva } from 'lib/configUtils';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { formatCurrency, formatData, formatDateForInput, formatTime } from 'lib/functions';

class AgendaEscalaFornecedorList extends Component {
    state = {
        searchFilter: loadStoredJson('agendaescalafornecedorSearchFilter', {
            datainicial: '',
            datafinal: ''
        }),
        agendaescalasfornecedores: [],
        configPartner: {},
        openAlert: false,
        messageAlert: '',
        totalItems: 0,
        page: Number(sessionStorage.getItem('agendaescalafornecedorPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('agendaescalafornecedorRowsPerPage')) || 10,
        sortField: sessionStorage.getItem('agendaescalafornecedorSortField') || 'CODITEMESCALA',
        sortOrder: sessionStorage.getItem('agendaescalafornecedorSortOrder') || 'DESC'
    };

    estilo = listStyles;

    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        const { searchFilter } = this.state;

        if (!searchFilter.datainicial || !searchFilter.datafinal) {
            const dataAtual = formatDateForInput(new Date());

            searchFilter.datainicial = searchFilter.datainicial || dataAtual;
            searchFilter.datafinal = searchFilter.datafinal || dataAtual;

            this.setState(
                { searchFilter },
                this.loadAgendaEscalasFornecedor
            );

            return;
        }

        this.loadAgendaEscalasFornecedor();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage, sortField, sortOrder } = this.state;

        // persiste filtros, paginação e ordenação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            saveStoredValue('agendaescalafornecedorSearchFilter', searchFilter);
        }

        if (prevState.page !== page) {
            saveStoredValue('agendaescalafornecedorPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            saveStoredValue('agendaescalafornecedorRowsPerPage', rowsPerPage);
        }

        if (prevState.sortField !== sortField) {
            saveStoredValue('agendaescalafornecedorSortField', sortField);
        }

        if (prevState.sortOrder !== sortOrder) {
            saveStoredValue('agendaescalafornecedorSortOrder', sortOrder);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        removeStoredKeys([
            'agendaescalafornecedorSearchFilter',
            'agendaescalafornecedorPage',
            'agendaescalafornecedorRowsPerPage',
            'agendaescalafornecedorSortField',
            'agendaescalafornecedorSortOrder'
        ]);
    };

    /* Carrega a agenda de escalas do fornecedor */
    loadAgendaEscalasFornecedor = async () => {
        const { page, rowsPerPage, searchFilter, sortField, sortOrder } = this.state;
        const { datainicial, datafinal } = searchFilter;
        const idPartner = sessionStorage.getItem('idPartner');

        const params = buildListParams({
            page,
            rowsPerPage,
            sortField,
            sortOrder,
            filters: [
                {
                    field: 'DATAINICIAL',
                    value: datainicial
                },
                {
                    field: 'DATAFINAL',
                    value: datafinal
                },
                {
                    field: 'CODFORNECEDORTRANSP',
                    value: idPartner
                }
            ]
        });

        try {
            const response = await api.get('/agendaescalafornecedor' + params);

            this.setState({
                agendaescalasfornecedores: getListData(response),
                configPartner: response.data.configPartner || {},
                totalItems: getTotalRecords(response)
            });
        } catch (error) {
            console.error('Erro ao carregar agenda de escalas do fornecedor:', error);

            this.setState({
                agendaescalasfornecedores: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadAgendaEscalasFornecedor);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadAgendaEscalasFornecedor);
    };

    /* Ordena os retornos da grid */
    handleSort = (field) => {
        this.setState((prevState) => {
            const isSameField = prevState.sortField === field;

            return {
                sortField: field,
                sortOrder: isSameField && prevState.sortOrder === 'ASC' ? 'DESC' : 'ASC',
                page: 0
            };
        }, this.loadAgendaEscalasFornecedor);
    };

    /* Renderiza o título ordenável da coluna */
    renderSortLabel = (field, label) => {
        const { sortField, sortOrder } = this.state;

        return (
            <TableSortLabel
                active={sortField === field}
                direction={sortField === field && sortOrder === 'DESC' ? 'desc' : 'asc'}
                onClick={() => this.handleSort(field)}
            >
                {label}
            </TableSortLabel>
        )
    }

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (name === 'datainicial' || name === 'datafinal')
                ? value
                : (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            datainicial: formatDateForInput(new Date()),
            datafinal: formatDateForInput(new Date())
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadAgendaEscalasFornecedor);
    };

    render() {
        const {
            agendaescalasfornecedores,
            configPartner,
            messageAlert,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            totalItems
        } = this.state;

        const {
            actionIcon,
            filterPaper,
            iconGroup
        } = this.estilo;

        const basePath = this.props.match.path.startsWith('/admpartner') ? '/admpartner' : '/partner';
        const exibeCustoFornecedorTransp = isFlagAtiva(configPartner, 'exibecustofornecedortransp');
        const totalCustoFornecedorTransp = agendaescalasfornecedores.reduce((total, item) => (
            total + Number(item.custofornecedortransp || 0)
        ), 0);

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    fullWidth
                    style={filterPaper}
                >
                    <FormControl
                        component="fieldset"
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #bdbdbd',
                            borderRadius: 12,
                            flex: '0 1 300px',
                            minWidth: 300,
                            justifyContent: 'center'
                        }}
                    >
                        <FormLabel
                            component="legend"
                            style={{
                                fontSize: 12,
                                padding: '0 4px',
                                color: '#616161'
                            }}
                        >
                            Período escala
                        </FormLabel>

                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8
                            }}
                        >
                            <Input
                                id="datainicial"
                                name="datainicial"
                                type="date"
                                value={searchFilter.datainicial || ''}
                                onChange={this.onChangeSearch}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120
                                }}
                            />

                            <span>a</span>

                            <Input
                                id="datafinal"
                                name="datafinal"
                                type="date"
                                value={searchFilter.datafinal || ''}
                                onChange={this.onChangeSearch}
                                style={{
                                    flex: '0 1 120px',
                                    minWidth: 120
                                }}
                            />
                        </div>
                    </FormControl>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.loadAgendaEscalasFornecedor}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlinedIcon
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div style={{ minWidth: exibeCustoFornecedorTransp ? 1050 : 900 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                {this.renderSortLabel('CODITEMESCALA', 'Nº Escala')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('HORASERVICO', 'Hora Serviço')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('DESCSERVICO', 'Serviço')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('DATASERVICO', 'Data Escala')}
                                            </TableCell>

                                            <TableCell align="center">
                                                {this.renderSortLabel('TOTALPAX', 'Total Pax')}
                                            </TableCell>

                                            {exibeCustoFornecedorTransp && (
                                                <TableCell align="center">
                                                    {this.renderSortLabel('CUSTOFORNECEDORTRANSP', 'Total Custo')}
                                                </TableCell>
                                            )}

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {agendaescalasfornecedores.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={exibeCustoFornecedorTransp ? 7 : 6}
                                                >
                                                    Nenhuma escala encontrada
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {agendaescalasfornecedores.map(agendaescalafornecedor => {
                                            const permiteEditar =
                                                isFlagAtiva(agendaescalafornecedor, 'informakminifim') ||
                                                isFlagAtiva(agendaescalafornecedor, 'registrafotokm') ||
                                                isFlagAtiva(configPartner, 'informakminifim') ||
                                                isFlagAtiva(configPartner, 'registrafotokm');

                                            return (
                                                <TableRow
                                                    hover
                                                    key={agendaescalafornecedor.coditemescala}
                                                >
                                                    <TableCell align="center">
                                                        {agendaescalafornecedor.coditemescala}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {formatTime(agendaescalafornecedor.horaservico)}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {agendaescalafornecedor.descservico}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {formatData(agendaescalafornecedor.dataservico)}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {agendaescalafornecedor.totalpax}
                                                    </TableCell>

                                                    {exibeCustoFornecedorTransp && (
                                                        <TableCell align="center">
                                                            {formatCurrency(agendaescalafornecedor.custofornecedortransp || 0)}
                                                        </TableCell>
                                                    )}

                                                    <TableCell align="center">
                                                        <span style={iconGroup}>
                                                            {permiteEditar && (
                                                                <Tooltip title="Editar">
                                                                    <Link to={`${basePath}/agendaescalafornecedor/${agendaescalafornecedor.coditemescala}`}>
                                                                        <EditTwoToneIcon
                                                                            onMouseEnter={this.handleIconMouseEnter}
                                                                            onMouseLeave={this.handleIconMouseLeave}
                                                                            style={actionIcon}
                                                                        />
                                                                    </Link>
                                                                </Tooltip>
                                                            )}

                                                            <Tooltip title="Visualizar">
                                                                <Link to={`${basePath}/agendaescalafornecedor/${agendaescalafornecedor.coditemescala}/view`}>
                                                                    <VisibilityOutlinedIcon
                                                                        onMouseEnter={this.handleIconMouseEnter}
                                                                        onMouseLeave={this.handleIconMouseLeave}
                                                                        style={actionIcon}
                                                                    />
                                                                </Link>
                                                            </Tooltip>
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        {exibeCustoFornecedorTransp && (
                            <div
                                style={{
                                    borderBottom: '1px solid #e0e0e0',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    padding: '12px 16px'
                                }}
                            >
                                <div
                                    style={{
                                        padding: '8px 16px',
                                        borderRadius: 12,
                                        border: '1px solid #c5d4e3',
                                        backgroundColor: '#eef5fc',
                                        color: '#1f5fa8',
                                        fontWeight: 700,
                                        fontSize: 15,
                                        fontFamily: 'Arial',
                                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                    }}
                                >
                                    Total Custo: R${formatCurrency(totalCustoFornecedorTransp)}
                                </div>
                            </div>
                        )}

                        <TablePagination
                            component="div"
                            count={totalItems}
                            page={page}
                            onPageChange={this.handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default AgendaEscalaFornecedorList;